// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-loader[data-v-21d7d30b] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ddd6fe;\n  border-radius: 8px;\n  min-height: 480px;\n}\n.ui-loader .not-fount[data-v-21d7d30b] {\n  font-size: 16px;\n  color: #69696c;\n}\n", ""]);
// Exports
module.exports = exports;
